import { isInternetConnected, isAppEnv } from "./CommonUtils";
import axios from "axios";
import { logObj, tokenObj } from "../../mobile/app/constants/Constant";
import { webRefreshTokenRedux } from "./Constants";
import { getEnvironment } from "../utils/EnvConfig";
import store from "../../web/src/SharedContextStore/store";

const instanceAxios = axios.create({
  // baseURL: API_URL,
});

instanceAxios.interceptors.request.use(async (config) => {
  // web app will throgh the error for isInternetConnected
  let isConnected = window.navigator.onLine || (await isInternetConnected());
  if (!isConnected) {
    // __Dev__ is not defined or in used shared so it through the Error in Web App so commented the logger as of now
    //logError("No internet");
    return Promise.reject("No internet");
  }
  // config.baseURL = await getBaseURL()
  if (!config.url) {
    return config;
  }

  var currentUrl = "";
  Object.entries(config?.url || {}).forEach(([k, v]) => {
    if (k !== "apiUrl") {
      currentUrl = `${currentUrl}${k}/${v}`;
    }
  });
  if (!isAppEnv()) {
    // only for web app
    await refreshWebToken(config);
  }


  /**
   * Handled URL replacement for Secure and Non-Auth APIs
   */

  const NAPATH = "iam/acm"
  const SECUREPATH = "digital/secure"
  const reduxStore = store.getState();

  function replaceInUrl(url, replacement) {
    if (typeof url !== 'string') return url;

    return url.replace(/\/digital(?:\/secure)?/, replacement);
  }

  // if (!reduxStore?.brightspeedToken?.headers?.['access-token'] || reduxStore?.brightspeedToken?.headers.flowType === 'NA') {
    
  //   const updatedURL = replaceInUrl(currentUrl, NAPATH)

  //   return {
  //     ...config,
  //     baseURL: config?.url?.apiUrl,
  //     url: updatedURL,
  //   };
  // }

  return {
    ...config,
    baseURL: config?.url?.apiUrl,
    // url: replaceInUrl(currentUrl, "digital", SECUREPATH),
    url: currentUrl
  };
});
instanceAxios.interceptors.response.use(
  (response) => {
    return Promise.resolve(response);
  },
  async (error) => {
    try {
      if (!!logObj && isAppEnv()) {
        let errorMessage = JSON.parse(JSON.stringify(error));

        if (errorMessage?.message?.includes("401")) {
          if (tokenObj?.refreshToken) {
            tokenObj?.refreshToken();
          }
        }
        logObj.log(error);
      }
      return Promise.reject(error);
    } catch (error) {
      // __Dev__ is not defined or in used shared so it through the Error in Web App so commented the logger as of now
      // log API error on crashlytics
      if (!!logObj && isAppEnv()) {
        logObj.log(error);
      }
      return Promise.reject(error);
    } finally {
    }
  }
);

async function refreshWebToken(config) {
  const env = getEnvironment();
  if (
    config?.headers?.Authorization &&
    config?.url?.apiUrl === env?.brightspeedApi
  ) {
    if (webRefreshTokenRedux?.webReduxStore) {
      const reduxStore = webRefreshTokenRedux?.webReduxStore?.getState();
      if (reduxStore?.brightspeedToken?.data?.expires_in) {
        if (new Date() > reduxStore?.brightspeedToken?.data?.expires_in) {
          // now refresh token here
          if (webRefreshTokenRedux?.refreshToken) {
            await webRefreshTokenRedux?.refreshToken();
          }
        }
      }
    }
  }
}

export default instanceAxios;
